import {
  Flex,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  InputGroup,
  Input,
  InputRightElement,
  SimpleGrid,
  Select,
  HStack,
  Text,
  ModalFooter,
  Icon,
  useDisclosure,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { SlMagnifier } from "react-icons/sl";
import { Content, HistoryContent } from "@/types/content";
import Consume1 from "@/assets/images/integral_img4.png";
import HistoryModalItem from "./historyModalItem";
import {
  ArrowBackIcon,
  ChevronDownIcon,
  CopyIcon,
  DownloadIcon,
  EditIcon,
  HamburgerIcon,
  StarIcon,
} from "@chakra-ui/icons";
import {
  RiCheckboxCircleLine,
  RiIndeterminateCircleLine,
  RiEditBoxLine,
  RiDeleteBin4Line,
} from "@remixicon/react";
import TimeLine from "./timeline";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { contentRemove, selectContentsAll } from "@/reducer/contentSlice";
import { selectCurrentImage, setCurrentImage } from "@/reducer/designslice";
import Client4 from "@/services/api/client4";
import TransitionDialog from "@/components/alertDialog";
import JSZip from 'jszip';
import FileSaver from 'file-saver';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const HistoryModal = (props: Props) => {
  const { isOpen, onClose } = props;
  const dispatch = useAppDispatch();
  const contents = useAppSelector(selectContentsAll);
  const [searchValue, setSearchValue] = useState("");
  const [renderType, setRenderType] = useState("");
  const [renderTime, setRenderTime] = useState("");
  const [isBatch, setIsBatch] = useState(false);
  const [arrayType, setArrayType] = useState<number>(1);
  const [images, setImages] = useState<Content[]>([]);
  const deleteControl = useDisclosure();
  const currentImage = useAppSelector(selectCurrentImage);

  const handlesImagesData = () => {
    const newImage = contents.map((item) => {
      return {
        ...item,
        isChecked: false,
      };
    });
    setImages(newImage);
  };
  useEffect(() => {
    handlesImagesData();
  }, [contents]);

  const handleChangeSearchValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const handleCloseStHistoryModal = () => {
    onClose();
    setIsBatch(false);
    setArrayType(1);
  };

  const handleChangeRenderType = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setRenderType(e.target.value);
  };

  const handleChangeRenderTime = (e: React.ChangeEvent<HTMLInputElement>) => {
    // console.log(e.target.value, ">>>>>>>>>>>>>>12345");
    setRenderTime(e.target.value);
  };

  const handleArrayType = (num: number) => {
    setArrayType(num);
    setIsBatch(false);
  };

  const handleBatch = () => {
    setIsBatch(true);
  };

  const handleCheckBox = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    let newImages = [...images];
    newImages.map((item) => {
      if (item.id === id) {
        item.isChecked = e.target.checked;
        return;
      }
    });
    setImages(newImages);
  };

  const handleCheckedAll = () => {
    let newImages = [...images];
    newImages.map((item) => (item.isChecked = true));
    setImages(newImages);
  };

  const handleCancelCheckedAll = () => {
    let newImages = [...images];
    newImages.map((item) => (item.isChecked = false));
    setImages(newImages);
    setIsBatch(false);
  };

  const checkedImages = images.filter((item) => item.isChecked === true);

  const handleBatchDelete = () => {
    if(checkedImages.length>0){
      deleteControl.onOpen();
    }
    
  };
  
  const handleDeleteChecked = () => {
    const hasCurrentImage = checkedImages.filter(
      (item) => item.id === currentImage.id
    );
    if (hasCurrentImage) {
      dispatch(setCurrentImage({} as Content));
    }

    checkedImages.map((item) => {
      dispatch(contentRemove(item.id));
      Client4.deleteContent(item.id);
    });
    deleteControl.onClose();
  };

  const handleSaveChecked = () => {
    if (checkedImages.length<0 || checkedImages.length==0) {
      return;
    }
    let blogTitle = "打包图片";
    let zip = new JSZip();
    let imgs = zip.folder(blogTitle);
    let baseList:string[] = [];

    checkedImages.map(async(item, index) => {
      let image = new Image();
        // 解决跨域 Canvas 污染问题
        image.setAttribute("crossOrigin", "anonymous");
        image.onload = function () {
          let canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          let context = canvas.getContext("2d");
          if (!context) return;
          context.drawImage(image, 0, 0, image.width, image.height);
          let url = canvas.toDataURL(); // 得到图片的base64编码数据
          canvas.toDataURL("image/png");
          baseList.push(url.substring(22)); // 去掉base64编码前的     data:image/png;base64,
          if (baseList.length === checkedImages.length && baseList.length > 0) {
            for (let k = 0; k < baseList.length; k++) {
              imgs!.file(`图片${Number(k) + 1}.png`, baseList[k], { base64: true });
            }
            zip.generateAsync({ type: "blob" }).then(function (content) {
              // see FileSaver.js
              FileSaver.saveAs(content, blogTitle + ".zip");
            });
          }
        };
        image.src = item.image_url;
    })
  };

  return (
    <>
      <Modal
        size={"6xl"}
        isOpen={isOpen}
        onClose={onClose}
        scrollBehavior="inside"
        closeOnOverlayClick={false}
      >
        <ModalOverlay sx={{ backgroundColor: "rgba(0, 0, 0, 0.7)" }} />
        <ModalContent bg="#0C0B10">
          <ModalHeader color="#FFFFFF" fontSize={"18px"}>
            生图历史
          </ModalHeader>
          <ModalCloseButton
            color={"#B9B9B9"}
            onClick={handleCloseStHistoryModal}
          />
          <Flex
            justifyContent={"space-between"}
            p="0 1.5rem"
            mt="10px"
            mb="10px"
          >
            <HStack>
              {/* <Button
                  w="60px"
                  h="32px"
                  leftIcon={<ArrowBackIcon boxSize={"24px"} />}
                  variant={"unstyle"}
                  borderRadius={0}
                  bg="none"
                  color={"#8E94A9"}
                  fontSize={"14px"}
                  fontWeight="bold"
                  _hover={{
                    bg: "none",
                    color: "#fff",
                  }}
                  onClick={handleCloseStHistoryModal}
                >
                  返回
                </Button> */}
              <Select
                w="180px"
                h="40px"
                ml="10px"
                placeholder="渲染类型"
                border="1px solid #27314D"
                bg="#0C0B10"
                color={"#FFFFFF"}
                size="lg"
                fontSize={"14px"}
                borderRadius={0}
                _hover={{
                  borderColor: "#496AE1",
                }}
                sx={{
                  "& option": {
                    bg: "#1C2337",
                    color: "#FFFFFF",
                    _hover: {
                      bg: "#0C0B10",
                    },
                    _active: {
                      bg: "#0C0B10",
                    },
                  },
                }}
                onChange={(e) => handleChangeRenderType(e)}
                value={renderType}
              >
                <option>室内设计</option>
                <option>建筑设计</option>
                <option>景观设计</option>
                <option>平面彩图</option>
                <option>获奖作品</option>
                <option>其他</option>
              </Select>
              <Text fontSize={"14px"} color="#fff" ml="10px">
                渲染时间:
              </Text>
              <Input
                placeholder="渲染时间"
                h="40px"
                w="180px"
                borderRadius={0}
                border="1px solid #27314D"
                bg="#8E94A9"
                color={"#FFFFFF"}
                size="lg"
                fontSize={"14px"}
                type="date"
                _hover={{
                  borderColor: "#496AE1",
                }}
                value={renderTime}
                onChange={handleChangeRenderTime}
              />
            </HStack>
            <HStack>
              <HStack spacing={0}>
                <Button
                  variant={"unstyle"}
                  borderRadius={"0"}
                  width={"86px"}
                  height={"34px"}
                  color={arrayType === 0 ? "#fff" : "#8E94A9"}
                  bgColor="none"
                  fontWeight={"normal"}
                  fontSize="14px"
                  border={"1px solid #8E94A9"}
                  leftIcon={<HamburgerIcon boxSize={"16px"} />}
                  _hover={{
                    color: "#fff",
                  }}
                  onClick={() => handleArrayType(0)}
                >
                  时间轴
                </Button>
                <Button
                  variant={"unstyle"}
                  borderRadius={"0"}
                  width={"86px"}
                  height={"34px"}
                  color={arrayType === 1 ? "#fff" : "#8E94A9"}
                  bgColor="none"
                  fontWeight={"normal"}
                  fontSize="14px"
                  border={"1px solid #8E94A9"}
                  leftIcon={<HamburgerIcon boxSize={"16px"} />}
                  _hover={{
                    color: "#fff",
                  }}
                  onClick={() => handleArrayType(1)}
                >
                  宫格
                </Button>
              </HStack>
              <InputGroup w="280px">
                <Input
                  h="34px"
                  // w="400px"
                  boxSizing="border-box"
                  border="1px solid #8E94A9"
                  borderRadius={0}
                  bg="none"
                  color={"#8E94A9"}
                  fontSize="12px"
                  placeholder="请输入"
                  size="md"
                  value={searchValue}
                  onChange={handleChangeSearchValue}
                />
                <InputRightElement>
                  <SlMagnifier color="#8E94A9" />
                </InputRightElement>
              </InputGroup>
            </HStack>
          </Flex>

          <ModalBody pb={6}>
            {/* 时间轴 */}
            {arrayType === 0 && (
              <TimeLine
                images={images}
                isBatch={isBatch}
                onClose={onClose}
                handleCheckBox={handleCheckBox}
              />
            )}

            {/* 宫格 */}
            {arrayType === 1 && (
              <Box>
                <SimpleGrid columns={6} spacing={"20px"}>
                  {images &&
                    images.map((item, index) => (
                      <Box key={item.id} cursor="pointer">
                        <HistoryModalItem
                          content={item}
                          index={index}
                          isBatch={isBatch}
                          onClose={onClose}
                          handleCheckBox={handleCheckBox}
                        />
                      </Box>
                    ))}
                </SimpleGrid>
              </Box>
            )}
          </ModalBody>
          <ModalFooter>
            {!isBatch && (
              <Box>
                <Button
                  ml="6px"
                  borderRadius={"0"}
                  // width={"56px"}
                  height={"40px"}
                  color="#FFFFFF"
                  bgColor="#496AE1"
                  fontWeight={"normal"}
                  fontSize="16px"
                  leftIcon={<RiEditBoxLine size={"18px"} />}
                  _hover={{
                    bgColor: "#3F5BC1",
                    color: "#E6E6E6",
                  }}
                  onClick={handleBatch}
                >
                  批量处理
                </Button>
              </Box>
            )}
            {isBatch && (
              <HStack>
                <Button
                  ml="6px"
                  borderRadius={"0"}
                  // width={"56px"}
                  height={"40px"}
                  color="#FFFFFF"
                  bgColor="#1C2337"
                  fontWeight={"normal"}
                  fontSize="16px"
                  leftIcon={<RiCheckboxCircleLine size={"18px"} />}
                  _hover={{
                    bgColor: "#0C101B",
                    color: "#E6E6E6",
                  }}
                  onClick={handleCheckedAll}
                >
                  全选
                </Button>
                <Button
                  ml="6px"
                  borderRadius={"0"}
                  // width={"56px"}
                  height={"40px"}
                  color="#FFFFFF"
                  bgColor="#1C2337"
                  fontWeight={"normal"}
                  fontSize="16px"
                  leftIcon={<RiIndeterminateCircleLine size={"18px"} />}
                  _hover={{
                    bgColor: "#0C101B",
                    color: "#E6E6E6",
                  }}
                  onClick={handleCancelCheckedAll}
                >
                  取消选中
                </Button>
                {/* <Button
                  ml="6px"
                  borderRadius={"0"}
                  // width={"56px"}
                  height={"40px"}
                  color="#FFFFFF"
                  bgColor="#1C2337"
                  fontWeight={"normal"}
                  fontSize="16px"
                  leftIcon={<CopyIcon boxSize={"16px"} />}
                  _hover={{
                    bgColor: "#0C101B",
                    color: "#E6E6E6",
                  }}
                >
                  复制到粘贴板
                </Button> */}
                <Button
                  ml="6px"
                  borderRadius={"0"}
                  // width={"56px"}
                  height={"40px"}
                  color="#FFFFFF"
                  bgColor="#DC4437"
                  fontWeight={"normal"}
                  fontSize="16px"
                  leftIcon={<RiDeleteBin4Line size={"16px"} />}
                  _hover={{
                    bgColor: "#B6372C",
                    color: "#E6E6E6",
                  }}
                  onClick={handleBatchDelete}
                >
                  删除选中
                </Button>
                <Button
                  ml="6px"
                  borderRadius={"0"}
                  // width={"56px"}
                  height={"40px"}
                  color="#FFFFFF"
                  bgColor="#496AE1"
                  fontWeight={"normal"}
                  fontSize="16px"
                  leftIcon={<DownloadIcon boxSize={"16px"} />}
                  _hover={{
                    bgColor: "#3F5BC1",
                    color: "#E6E6E6",
                  }}
                  onClick={handleSaveChecked}
                >
                  批量保存
                </Button>
              </HStack>
            )}
          </ModalFooter>

          <TransitionDialog
            isOpen={deleteControl.isOpen}
            onClose={deleteControl.onClose}
            onDelete={handleDeleteChecked}
          />
        </ModalContent>
      </Modal>
    </>
  );
};

export default HistoryModal;
